"use client";

import Link from "next/link";
const linkStyle = "text-sm leading-[1.375em] text-white hover:text-white/80";
const About = () => {
  return <div className='shrink-0' data-sentry-component="About" data-sentry-source-file="About.tsx">
      <h3 className='mb-[19px] text-base font-semibold leading-[1.5em] text-white'>
        Explore
      </h3>
      <div className='flex flex-col gap-[7px]'>
        <Link href='/about-us' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="About.tsx">
          About us
        </Link>

        <Link href='/signup' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="About.tsx">
          Sign Up
        </Link>

        <Link href='/resources' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="About.tsx">
          Resources
        </Link>
        <Link href='/help-support-center' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="About.tsx">
          Help Center
        </Link>
        <Link href='/frequently-asked-questions' className={linkStyle} data-sentry-element="Link" data-sentry-source-file="About.tsx">
          FAQ&apos;s
        </Link>
      </div>
    </div>;
};
export default About;